import { jsx as t, jsxs as e } from "react/jsx-runtime";
import { forwardRef as r } from "react";
import o from "../../../assets/EmptyInfo.svg.js";
import { useTheme as i } from "@mui/joy";
import l from "@mui/joy/Stack";
import m from "@mui/joy/Typography";
const n = r(({ error: r2, button: n2, icon: a, title: p, subtitle: s, sx: c }, f) => {
  const u = i(), y = t(o, { style: { fill: r2 ? u.palette.danger[500] : u.palette.isDarkMode ? u.palette.primary[700] : u.palette.primary[500] } });
  return e(l, { ref: f, sx: { justifyContent: "center", alignItems: "center", textAlign: "center", py: 2, gap: 1, ...c }, children: [a ?? y, t(m, { level: "title-md", textColor: "neutral.700", fontWeight: 600, children: p }), s ? t(m, { component: "div", level: "body-sm", textColor: "neutral.700", sx: { maxWidth: "450px" }, children: s }) : null, n2] });
});
export {
  n as default
};
//# sourceMappingURL=index.js.map
